import {
    REQUEST_PBN,
    RECEIVE_PBN,
    PLAY_CARD,
    RESET_CARDS, PREVIOUS_AUCTION, NEXT_AUCTION, SHOW_AUCTION, RESET_AUCTION
} from '../actions'

const startOfHand = 0, endOfHand = 1;
const spades = 0, hearts = 1, diamonds = 2, clubs = 3, notrumps = 4;
const northPlayer = 0, eastPlayer = 1, southPlayer = 2, westPlayer = 3;
const theAsciiCodeDigitTwo = "2".charCodeAt(0);
const theAsciiCodeDigitNine = "9".charCodeAt(0);

const initState = {
    pbnGamesTextArray: [],
    pbnGamesArray: [[], []],
    pbnGamesArrayPointer: 0,
    pbnGamesArrayToUse : 0,
    pnbSite: "",
    pbnEvent: "",
    pbnBoardNumber: 0,
    pbnDealer: 0,
    pbnVulnerable: "",
    pbnScoring: "",
    pbnNorthPlayer: "",
    pbnEastPlayer: "",
    pbnSouthPlayer: "",
    pbnWestPlayer: "",
    pbnDeclarer: 0,
    pbnContract: "",
    pbnResult: "",
    pbnCommentary: "",
    trumps: 0,
    auction: {
        auctionArray: [],
        auctionArrayCounter: 0
    },

    play: {
        playArray: [],
        playArrayCounter: 0
    },
    auctionProgressPointer: 0,
    bidAttitudePointer: 0,
    pbnBidsDivsPointer: 0,
    openingLeadPlayer: 0,
    currentPlayerOnLead: 0,
    playerOnLead: 0,
    trickNumber: 0,
    tricksNS: 0,
    tricksEW: 0,
    trickCardsPlayed: 0,
    playAttitudePointer: 0,
    nextCardToPlayPointer: 0,
    northCard: "",
    eastCard: "",
    southCard: "",
    westCard: "",
    continueScanFrom: 0,
    howManyTricksClaimed: 0,
    northCards: "",
    eastCards: "",
    southCards: "",
    westCards: "",
    northPbnCards: [
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X']
    ],
    eastPbnCards: [
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X']
    ],
    southPbnCards: [
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X']
    ],
    westPbnCards: [
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X']
    ]
};

function readPBN(pbnJson) {
    let pbnGamesTextArray = pbnJson.pbn;
    let pbnGamesArray = [[], []];
    let pbnGamesArrayPointer = 0;

    for (let i=0; i<pbnGamesTextArray.length; i++) {
        pbnGamesTextArray[i] = pbnGamesTextArray[i].replace(/(\r\n|\n|\r)/gm,"");
    }

    let endOfPbnGame = 0;
    for (let i = 0; i < pbnGamesTextArray.length; i++) {
        endOfPbnGame = findEndOfGame(i, pbnGamesTextArray);
        if(endOfPbnGame != -1) {
            pbnGamesArray[startOfHand][pbnGamesArrayPointer] = i;
            pbnGamesArray[endOfHand][pbnGamesArrayPointer] = endOfPbnGame;
            pbnGamesArrayPointer++;
            i = endOfPbnGame;
        }
    }

    return Object.assign(
        {},
        initState,
        {
            pbnGamesTextArray: pbnGamesTextArray,
            pbnGamesArray: pbnGamesArray,
            pbnGamesArrayPointer: pbnGamesArrayPointer,
            pbnGamesArrayToUse: 1
        }
    );
}

function pbnParser(state) {
    let result = {};

    // let pbnGamesTextArray = Object.assign({}, state.pbnGamesTextArray);
    // let pbnGamesArray = Object.assign({}, state.pbnGamesArray);
    // let pbnGamesArrayToUse = state.pbnGamesArrayToUse;

    var tempString;
    var tempArray = [];
    var tempCounter = 0;

    for (let i = state.pbnGamesArray[startOfHand][state.pbnGamesArrayToUse - 1]; i <= state.pbnGamesArray[endOfHand][state.pbnGamesArrayToUse - 1]; i++) {
        tempArray[tempCounter] = state.pbnGamesTextArray[i];
        tempCounter++;
    }

    let pbnTextArray = tempArray;
    // let auctionProgressPointer = 0;
    let theEndOfGame = pbnTextArray.length;

    result.pbnSite = pbnSubstring(7, searchPbnTextArray("Site ", pbnTextArray, theEndOfGame));
    result.pbnEvent = pbnSubstring(8, searchPbnTextArray("Event ", pbnTextArray, theEndOfGame));
    result.pbnDate = formatDate(pbnSubstring(0,searchPbnTextArray("Date ",pbnTextArray, theEndOfGame)));

    result.pbnBoardNumber = pbnSubstring(8,searchPbnTextArray("Board ",pbnTextArray, theEndOfGame));
    result.pbnDealer = getPosition(pbnSubstring(9, searchPbnTextArray("Dealer ", pbnTextArray, theEndOfGame)));
    result.pbnVulnerable = pbnSubstring(13, searchPbnTextArray("Vulnerable ", pbnTextArray, theEndOfGame));
    result.pbnScoring = pbnSubstring(10, searchPbnTextArray("Scoring ", pbnTextArray, theEndOfGame));
    result.pbnNorthPlayer = pbnSubstring(8, searchPbnTextArray("North ", pbnTextArray, theEndOfGame));
    result.pbnEastPlayer = pbnSubstring(7, searchPbnTextArray("East ", pbnTextArray, theEndOfGame));
    result.pbnSouthPlayer = pbnSubstring(8, searchPbnTextArray("South ", pbnTextArray, theEndOfGame));
    result.pbnWestPlayer = pbnSubstring(7, searchPbnTextArray("West ", pbnTextArray, theEndOfGame));

    result.pbnDeclarer = getPosition(pbnSubstring(11, searchPbnTextArray("Declarer ", pbnTextArray, theEndOfGame)));

    switch (result.pbnDeclarer) {
        case northPlayer:
            result.openingLeadPlayer = eastPlayer;
            break;
        case eastPlayer:
            result.openingLeadPlayer = southPlayer;
            break;
        case southPlayer:
            result.openingLeadPlayer = westPlayer;
            break;
        case westPlayer:
            result.openingLeadPlayer = northPlayer;
            break;
    }

    result.pbnContract = pbnSubstring(11, searchPbnTextArray("Contract ", pbnTextArray, theEndOfGame));
    result.pbnResult = pbnSubstring(9, searchPbnTextArray("Result ", pbnTextArray, theEndOfGame))

    result.pbnCommentary = searchPbnTextArrayForAnnotation(pbnTextArray);

    // document.getElementById("PbnBoardNumber").innerHTML = "Board: " + makeBlue(pbnSubstring(8,searchPbnTextArray("Board ",pbnTextArray)));
    // document.getElementById("PbnDealer").innerHTML = "Dealer: " + makeBlue(convertDealer(pbnSubstring(9,searchPbnTextArray("Dealer ",pbnTextArray))));
    // document.getElementById("PbnVulnerable").innerHTML = "Vulnerable: " + makeBlue(pbnSubstring(13,searchPbnTextArray("Vulnerable ",pbnTextArray)));
    // document.getElementById("PbnScoring").innerHTML = "Scoring: " + makeBlue(convertScoring(pbnSubstring(10,searchPbnTextArray("Scoring ",pbnTextArray))));
    // document.getElementById("PbnNorth").innerHTML = pbnSubstring(8,searchPbnTextArray("North ",pbnTextArray));
    // document.getElementById("PbnEast").innerHTML = pbnSubstring(7,searchPbnTextArray("East ",pbnTextArray));
    // document.getElementById("PbnSouth").innerHTML = pbnSubstring(8,searchPbnTextArray("South ",pbnTextArray));
    // document.getElementById("PbnWest").innerHTML = pbnSubstring(7,searchPbnTextArray("West ",pbnTextArray));
    // document.getElementById("PbnCommentary").innerHTML = searchPbnTextArrayForAnnotation();
    // document.getElementById("PbnDeclarer").innerHTML = "Declarer: " + makeBlue(convertDeclarer(pbnSubstring(11,searchPbnTextArray("Declarer ",pbnTextArray))));
    // document.getElementById("PbnTrickNumber").innerHTML = "Tricks Played:";
    // document.getElementById("PbntricksNS").innerHTML = "NS Tricks:";
    // document.getElementById("PbntricksEW").innerHTML = "EW Tricks:";
    // theContract = pbnSubstring(11,searchPbnTextArray("Contract ",pbnTextArray));
    //document.getElementById("PbnContract").innerHTML = theContract;
    // document.getElementById("PbnContract").innerHTML = convertContract(theContract);
    // document.getElementById("PbnResult").innerHTML = "Result: " + makeBlue(pbnSubstring(9,searchPbnTextArray("Result ", pbnTextArray)));
    result.trumps = findTrumps(result.pbnContract);

    result.auction = getAuctionFromPbnTextArray(pbnTextArray, theEndOfGame);
    if(result.auction.auctionArrayCounter === 0) {
        alert('No Auction Data Found!');
    }

    tempString = searchPbnTextArray("Deal ", pbnTextArray, theEndOfGame);
    switch (tempString.substring(7,8)) {
        case 'N':
            result.northCards = tempString.substring(9,25);
            result.eastCards = tempString.substring(26,42);
            result.southCards = tempString.substring(43,59);
            result.westCards = tempString.substring(60,76);
            break;
        case 'E':
            result.eastCards = tempString.substring(9,25);
            result.southCards = tempString.substring(26,42);
            result.westCards = tempString.substring(43,59);
            result.northCards = tempString.substring(60,76);
            break;
        case 'S':
            result.southCards = tempString.substring(9,25);
            result.westCards = tempString.substring(26,42);
            result.northCards = tempString.substring(43,59);
            result.eastCards = tempString.substring(60,76);
            break;
        case 'W':
            result.westCards = tempString.substring(9,25);
            result.northCards = tempString.substring(26,42);
            result.eastCards = tempString.substring(43,59);
            result.southCards = tempString.substring(60,76);
            break;
    }

    // document.getElementById("PbnNorthSpades").innerHTML = getCardsInHand(northPbnCards[spades]);
    // document.getElementById("PbnNorthHearts").innerHTML = getCardsInHand(northPbnCards[hearts]);
    // document.getElementById("PbnNorthDiamonds").innerHTML = getCardsInHand(northPbnCards[diamonds]);
    // document.getElementById("PbnNorthClubs").innerHTML = getCardsInHand(northPbnCards[clubs]);
    // document.getElementById("PbnEastSpades").innerHTML = getCardsInHand(eastPbnCards[spades]);
    // document.getElementById("PbnEastHearts").innerHTML = getCardsInHand(eastPbnCards[hearts]);
    // document.getElementById("PbnEastDiamonds").innerHTML = getCardsInHand(eastPbnCards[diamonds]);
    // document.getElementById("PbnEastClubs").innerHTML = getCardsInHand(eastPbnCards[clubs]);
    // document.getElementById("PbnSouthSpades").innerHTML = getCardsInHand(southPbnCards[spades]);
    // document.getElementById("PbnSouthHearts").innerHTML = getCardsInHand(southPbnCards[hearts]);
    // document.getElementById("PbnSouthDiamonds").innerHTML = getCardsInHand(southPbnCards[diamonds]);
    // document.getElementById("PbnSouthClubs").innerHTML = getCardsInHand(southPbnCards[clubs]);
    // document.getElementById("PbnWestSpades").innerHTML = getCardsInHand(westPbnCards[spades]);
    // document.getElementById("PbnWestHearts").innerHTML = getCardsInHand(westPbnCards[hearts]);
    // document.getElementById("PbnWestDiamonds").innerHTML = getCardsInHand(westPbnCards[diamonds]);
    // document.getElementById("PbnWestClubs").innerHTML = getCardsInHand(westPbnCards[clubs]);
    result.play = getPlayFromPbnTextArray(pbnTextArray, theEndOfGame);

    if(result.play.playArrayCounter === 0) {
        alert('No Play Data Found!');
    }

    // resetCards();
    // hideAuction();
    // showPbnViewer();

    return result;
}

function findEndOfGame(startpoint, pbnTextArray) {
    let startOfHand = -1;
    let firstCharacter = "";
    let lastCharacter = "";
    let theCharacter = "";
    let thePreviousCharacter = "";
    let annotationFound = false;

    let x;

    for(x = startpoint; x < pbnTextArray.length;x++) {
        if(pbnTextArray[x].length === 1) {
            return -1;
        }

        firstCharacter = pbnTextArray[x].substring(0,1);
        lastCharacter = pbnTextArray[x].substring(pbnTextArray[x].length -1,pbnTextArray[x].length);
        // Annotation could come first ...
        if(annotationFound === true) {
            if(lastCharacter === "}") {
                annotationFound = false;
            }
        } else if(firstCharacter === "{") {
            annotationFound = true;
        } else if(firstCharacter === "[") {
            startOfHand = x;
            break;
        }
    }

    if(startOfHand === -1) {
        return startOfHand;
    }

    for(x = startOfHand; x < pbnTextArray.length; x++) {
        for(let i = 0; i< pbnTextArray[x].length; i++) {
            theCharacter = pbnTextArray[x].substring(i,i+1);
            if (i === 0) {
                thePreviousCharacter = "START";
            } else {
                thePreviousCharacter = pbnTextArray[x].substring(i-1,i);
            }

            if(annotationFound === true) {
                if(theCharacter === "}") {
                    annotationFound = false;
                }
            } else if(theCharacter === "{") {
                annotationFound = true;
            } else {
                if(pbnTextArray[x].length === 1 || (theCharacter === " "  && thePreviousCharacter === "START" && pbnTextArray[x].length === 1)) {
                    return x;
                }
            }
        }
    }

    return x - 1;
}

function findTrumps(theContract) {
    var theTrumps = notrumps;
    switch (theContract.substring(1, 2)) {
        case "S":
            return spades;
        case "H":
            return hearts;
        case "D":
            return diamonds;
        case "C":
            return clubs;
    }

    return theTrumps;
}

function getAuctionFromPbnTextArray(pbnTextArray, theEndOfGame) {
    var auctionPointer = 0;
    var auctionFound = false;
    var searchPosition = 0;
    var tempString = "";
    var tempString2 = "";
    var theAlertString = "";
    var alertedBidFound = false;
    var alertedBidEnd = false;
    var annotationFound = false;
    var theAnnotationString = "";

    let auctionArray = [];
    let auctionArrayCounter = 0;
    for(let x = 0; x < theEndOfGame; x++) {
        if(auctionFound === false) {
            searchPosition = pbnTextArray[x].search('Auction "');
            if(searchPosition >= 1) {
                auctionFound = true;
            }
        } else {
            tempString = pbnTextArray[x].substring(0, 1);
            if(tempString === '[' || tempString === '*' || tempString === null) {
                x = theEndOfGame; // Break out of the loop
            } else {
                for(let i = 0; i < pbnTextArray[x].length; i++) {
                    tempString = pbnTextArray[x].substring(i, i + 1);
                    if(alertedBidFound == true) {
                        if(tempString === "=") {
                            theAlertString = theAlertString + "=";
                            tempString = "";
                            tempString2 = "";
                            alertedBidFound = false;
                            theAlertString = "";
                            auctionArray[auctionArrayCounter - 1] = auctionArray[auctionArrayCounter - 1] + "!";
                        } else {
                            theAlertString = theAlertString + tempString;
                        }
                    } else if(annotationFound === true) {
                        if(tempString === "}") {
                            tempString = "";
                            tempString2 = "";
                            annotationFound = false;
                            theAnnotationString = "";
                        } else {
                            theAnnotationString = theAnnotationString + tempString;
                        }
                    } else {
                        // Normal
                        if(tempString === "=") {
                            if(tempString2 != "") {
                                auctionArray[auctionArrayCounter] = tempString2;
                                auctionArrayCounter++;
                            }

                            alertedBidFound = true;
                            theAlertString = "=";
                            tempString = "";
                            tempString2 = "";
                        } else if(tempString === "{") {
                            annotationFound = true;
                            if(tempString2 != "") {
                                auctionArray[auctionArrayCounter] = tempString2;
                                auctionArrayCounter++;
                                theAnnotationString = "";
                                tempString = "";
                                tempString2 = "";
                            }
                        } else {
                            if(tempString === " " && tempString2 != "") {
                                auctionArray[auctionArrayCounter] = tempString2;
                                tempString = "";
                                tempString2 = "";
                                theAlertString = "";
                                auctionArrayCounter++;
                            } else {
                                if(tempString != " ") {
                                    tempString2 = tempString2 + tempString;
                                }
                            }
                        }
                    }
                }

                if(tempString != "" && tempString2 != "") {
                    auctionArray[auctionArrayCounter] = tempString2;
                    tempString = "";
                    tempString2 = "";
                    auctionArrayCounter++;
                    alertedBidFound = false;
                    alertedBidEnd = false;
                    theAlertString = "=";
                }
            }
        }
    }

    if(tempString != "" && tempString2 != "") {
        auctionArray[auctionArrayCounter] = tempString2;
        auctionArrayCounter++;
    }

    // auctionArrayCounter--;

    return {
        auctionArray: auctionArray,
        auctionArrayCounter: auctionArrayCounter
    };
}

function getPlayFromPbnTextArray(pbnTextArray, theEndOfGame) {
    var playPointer = 0;
    var playFound = false;
    var playsFound = 0;
    var searchPosition = 0;
    var tempString = "";
    var tempString2 = "";
    var annotationFound = false;
    var theAnnotationString = "";

    let playArray = [] ;
    let playArrayCounter = 0;

    for(let x = 0; x < theEndOfGame; x++) {
        if(playFound === false) {
            searchPosition = pbnTextArray[x].search('Play "');
            if(searchPosition >= 1) {
                playFound = true;
            }
        } else {
            tempString = pbnTextArray[x].substring(0,1);
            if(tempString === '[' || tempString === '*' || tempString === null || tempString === '-') {
                x = theEndOfGame;
            } else {
                tempString = "";
                for(let i = 0; i < pbnTextArray[x].length; i++) {
                    tempString = pbnTextArray[x].substring(i, i + 1);

                    if(annotationFound === true) {
                        if(tempString === "}") {
                            tempString = "";
                            tempString2 = "";
                            annotationFound = false;
                            theAnnotationString = "";
                        } else {
                            theAnnotationString = theAnnotationString + tempString;
                        }
                    } else {
                        if(tempString === "{") {
                            annotationFound = true;
                            if(tempString === " " && tempString2 != "") {
                                playArray[playArrayCounter] = tempString2;
                                tempString = "";
                                tempString2 = "";
                                playArrayCounter++;
                                theAnnotationString = "";
                                tempString = "";
                                tempString2 = "";
                            }
                        } else {
                            if(tempString === " " && tempString2 != "") {
                                playArray[playArrayCounter] = tempString2;
                                tempString = "";
                                tempString2 = "";
                                playArrayCounter++;
                            } else {
                                if(tempString == '-') {
                                    tempString2 = "";
                                    tempString = "";
                                    break;

                                } else {
                                    if(tempString != " ") {
                                        tempString2 = tempString2 + tempString;
                                    }
                                }
                            }
                        }
                    }
                }

                if(tempString != "" && tempString2 != "") {
                    playArray[playArrayCounter] = tempString2;
                    tempString = "";
                    tempString2 = "";
                    playArrayCounter++;
                }
            }
        }
    }

    if(tempString != "" && tempString2 != "" && tempString2 != '-') {
        playArray[playArrayCounter] = (tempString2);
        playArrayCounter++;
    }

    playArrayCounter--;

    return {
        playArray: playArray,
        playArrayCounter: playArrayCounter
    }
}

// function showSuitSymbols(theString) {
//     var tempString2 = "";
//     var alertedString = "";
//     if(theString == "X") {
//         return "X";
//     }
//
//     if(theString == "XX") {
//         return "XX";
//     }
//
//     if(theString == "Pass") {
//         return "Pass";
//     }
//
//     if((theString.length == 4) &&  (theString.substring(0, 2) == "Pass")) {
//         return "Pass";
//     }
//
//     if((theString.length === 3) && (theString.substring(2, 3) == "!")) {
//         alertedString = "!";
//     }
//
//     if(theString.length > 1) {
//         tempString2 = theString.substring(1,2);
//         if(tempString2 == "S") {
//             tempString2 = theString.substring(0,1) +  "&spades;" + alertedString;
//         } else if(tempString2 == "H") {
//             tempString2 = theString.substring(0,1) + "<font color=red>&hearts;</font>" + alertedString;
//         } else if(tempString2 == "D") {
//             tempString2 = theString.substring(0,1) +  "<font color=orange>&diams;</font>" + alertedString;
//         } else if(tempString2 == "C") {
//             tempString2 = theString.substring(0,1) +  "<font color=grey>&clubs;</font>" + alertedString;
//         } else if(tempString2 == "N") {
//             tempString2 = theString.substring(0,1) + "NT" + alertedString;
//         }
//     }
//
//     return tempString2;
// }

function dealCards(pbnCards, thePbnCards) {
    var theSuit = spades;
    var theSuitPointer = 0;
    var theRank = 0;
    var theCardsArrayPointer = 0;
    var thePbnCard;
    for(let i = 0; i < 16; i++) {
        thePbnCard = pbnCards.substring(i, i + 1);
        if(thePbnCard === '.') {
            theSuit++;
            theSuitPointer = 0;
        } else {
            thePbnCards[theSuit][theSuitPointer] = thePbnCard;
            theSuitPointer++;
            theCardsArrayPointer++;
        }
    }
}

function searchPbnTextArrayForAnnotation(pbnTextArray) {
    var tempString = "";
    var theClaimAnnotation = "";
    var annotationFound = false;
    var searchPosition;

    let howManyTricksClaimed = 0;
    for (let x = 0; x < pbnTextArray.length;x++) {
        for (let i = 0; i < pbnTextArray[x].length;i++) {
            tempString = pbnTextArray[x].substring(i,i+1);
            if (annotationFound == true) {
                if (tempString === "}") {
                    if(theClaimAnnotation.substring(2,9) === "claimed") {
                        howManyTricksClaimed = parseInt(theClaimAnnotation.substring(10,12));
                        return theClaimAnnotation;
                    } else {
                        theClaimAnnotation = "";
                    }

                    annotationFound = false;
                } else {
                    theClaimAnnotation = theClaimAnnotation + tempString;
                }
            } else {
                if (tempString === "{") {
                    annotationFound = true;
                }
            }
        }
    }

    return theClaimAnnotation;
}

function pbnSubstring(start, theString) {
    if(theString === "") {
        return theString;
    }

    var tempString = theString.substring(start, theString.length - 2);
    if(tempString === 'BridgeClubLive!') {
        tempString = 'BridgeClubLive'
    }

    return tempString;
}

function searchPbnTextArray(searchFor, pbnTextArray, theEndOfGame) {
    for(let x = 0; x < theEndOfGame; x++) {
        var searchPosition = pbnTextArray[x].search(searchFor);
        if(searchPosition === 1) {
            return pbnTextArray[x];
        }
    }

    return "";
}

function formatDate(theDate) {
    if(theDate === "") {
        return "";
    }

    var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var theMonth = monthNames[parseInt(theDate.substring(12, 14)) -1];
    var theDay = theDate.substring(15,17);
    var theYear = theDate.substring(7,11);
    return theMonth + " " + theDay + " " + theYear;
}

function getPosition(dealer) {
    switch (dealer) {
        case "N":
            return northPlayer;
        case "E":
            return eastPlayer;
        case "S":
            return southPlayer;
        case "W":
            return westPlayer;
    }

    return -1;
}

function findCardSuit(theCard) {
    let theSuit = theCard;
    switch (theCard.substring(0,1)) {
        case "S":
            theSuit = spades;
            break;
        case "H":
            theSuit = hearts;
            break;
        case "D":
            theSuit = diamonds;
            break;
        case "C":
            theSuit = clubs;
            break;
    }

    return theSuit;
}

function findCardRank(theCard) {
    return theCard.substring(1,2);
}

function findCardNumericRank(theCard) {
    let rawRank = findCardRank(theCard);
    switch (rawRank) {
        case "A":
            return 14;
        case "K":
            return 13;
        case "Q":
            return 12;
        case "J":
            return 11;
        case "T":
            return 10;
        default:
            return parseInt(rawRank);
    }

    return -1;
}

function convertPbnCard(theSuit, thePbnCard) {
    let theAsciiCode = thePbnCard.charCodeAt(0);
    if(theAsciiCode <= theAsciiCodeDigitNine) {
        return (theSuit * 13) + theAsciiCode - theAsciiCodeDigitTwo;
    }

    if(thePbnCard == 'T') {
        return (theSuit * 13) + 8;
    }

    if(thePbnCard == 'J') {
        return (theSuit * 13) + 9;
    }

    if(thePbnCard == 'Q') {
        return (theSuit * 13) + 10;
    }

    if(thePbnCard == 'K') {
        return (theSuit * 13) + 11;
    }

    if(thePbnCard == 'A') {
        return (theSuit * 13) + 12;
    }

    return -1;
}

// function convertDealer(dealer) {
//     var tempString = "Error";
//     switch (dealer) {
//         case "N":
//             tempString = "North";
//             theDealer = northPlayer;
//             break;
//         case "E":
//             tempString = "East";
//             theDealer = eastPlayer;
//             break
//         case "S":
//             tempString = "South";
//             theDealer = southPlayer;
//             break;
//         case "W":
//             tempString = "West";
//             theDealer = westPlayer;
//             break;
//     }
//
//     bidAttitudePointer = theDealer;
//     pbnBidsDivsPointer = theDealer;
//     auctionProgressPointer = 0;
//     // bidsShown = 0;
//     return tempString
// }

function setupTrickArray(trickNumber, playArray) {
    let trickArray = [];
    let counter = 0;
    for(let i = trickNumber*4; i < (trickNumber*4 + 4); i++) {
        trickArray[counter] = playArray[i];
        counter++;
    }

    return trickArray;
}

function previousAuction(state) {
    if (state.auctionProgressPointer <= 0) {
        return {
            auctionProgressPointer: state.auctionProgressPointer
        }
    };

    return {
        auctionProgressPointer: state.auctionProgressPointer - 1
    };
}

function nextAuction(state) {
    if (state.auctionProgressPointer >= state.auction.auctionArrayCounter) {
        return {
            auctionProgressPointer: state.auctionProgressPointer
        }
    };

    return {
        auctionProgressPointer: state.auctionProgressPointer + 1
    };
}

function showAuction(state) {
    return {
        auctionProgressPointer: state.auction.auctionArrayCounter
    };
}

function resetAuction(state) {
    return {
        auctionProgressPointer: 0
    };
}

function playCard(state) {
    var declarerTricks = 0;
    var trickWinner = 0;
    var highlightedStart = "";
    var highlightedEnd = "";
    var cardPlayed = "";
    var rawCardPlayed = "";

    if(state.play.playArrayCounter == 0) {
        alert('Select a deal first please');
        return state;
    }

    let trickNumber = state.trickNumber;
    let tricksNS = state.tricksNS;
    let tricksEW = state.tricksEW;
    let trickArray = state.trickArray.slice();
    let nextCardToPlayPointer = state.nextCardToPlayPointer;
    let trickCardsPlayed = state.trickCardsPlayed;
    let playAttitudePointer = state.playAttitudePointer;
    let currentPlayerOnLead = state.currentPlayerOnLead;
    let playerOnLead = state.playerOnLead;
    let northCard = state.northCard;
    let eastCard = state.eastCard;
    let southCard = state.southCard;
    let westCard = state.westCard;

    if(trickNumber === 13) {
        return state;
    }

    if (typeof trickArray[nextCardToPlayPointer] === "undefined") {
        return state;
    }

    if(trickCardsPlayed == 0) {
        currentPlayerOnLead = playerOnLead;
        northCard = "";
        eastCard = "";
        southCard = "";
        westCard = "";
        // document.getElementById(pbnPlayDivs[northPlayer]).innerHTML = "&nbsp;";
        // document.getElementById(pbnPlayDivs[eastPlayer]).innerHTML = "&nbsp;";
        // document.getElementById(pbnPlayDivs[southPlayer]).innerHTML = "&nbsp;";
        // document.getElementById(pbnPlayDivs[westPlayer]).innerHTML = "&nbsp;";
        // highlightedStart = "<span class='highlightCard'>";
        // highlightedEnd = "</span>";

    } else {
        // highlightedStart = "";
        // highlightedEnd = "";
    }

    rawCardPlayed = trickArray[nextCardToPlayPointer];
    // cardPlayed = convertCardPlayed(rawCardPlayed);
    switch (playAttitudePointer) {
        case northPlayer:
            northCard = rawCardPlayed;
            // document.getElementById(pbnPlayDivs[northPlayer]).innerHTML = highlightedStart + cardPlayed + highlightedEnd;
            break;
        case eastPlayer:
            eastCard = rawCardPlayed;
            break;
        case southPlayer:
            southCard = rawCardPlayed;
            break;
        case westPlayer:
            westCard = rawCardPlayed;
            break;
    }

    let removeResult = removeCardFromHand(state, playAttitudePointer, rawCardPlayed);
    playAttitudePointer++;
    trickCardsPlayed++;
    nextCardToPlayPointer++;
    if(nextCardToPlayPointer > westPlayer) {
        nextCardToPlayPointer = northPlayer;
    }

    if(playAttitudePointer > westPlayer) {
        playAttitudePointer = northPlayer;
    }

    if(trickCardsPlayed > 3) {
        trickWinner = findTrickWinner(trickArray, state.openingLeadPlayer, playerOnLead, state.trumps);
        switch (trickWinner) {
            case 0:
                nextCardToPlayPointer = 0;
                break;
            case 1:
                nextCardToPlayPointer = 1;
                break;
            case 2:
                nextCardToPlayPointer = 2;
                break;
            case 3:
                nextCardToPlayPointer = 3;
                break;
        }

        trickWinner = trickWinner + state.openingLeadPlayer;
        if(trickWinner > 3) {
            trickWinner = trickWinner - 4;
        }

        playerOnLead = playAttitudePointer = trickWinner;
        if((playerOnLead == northPlayer) || (playerOnLead == southPlayer)) {
            tricksNS++;
        } else {
            tricksEW++;
        }

        trickNumber++;
        trickArray = setupTrickArray(trickNumber, state.play.playArray);
        trickCardsPlayed = 0;
    }

    // document.getElementById("PbnTrickNumber").innerHTML = "Tricks Played: " + makeBlue(trickNumber);
    // document.getElementById("PbntricksNS").innerHTML = "NS Tricks: " + makeBlue(tricksNS);
    // document.getElementById("PbntricksEW").innerHTML = "EW Tricks: " + makeBlue(tricksEW);
    // if(trickNumber === 13) {
    //     document.getElementById("PbnPlayOver").innerHTML = makeBlue("End of Play");
    // }

    // if (typeof trickArray[nextCardToPlayPointer] === "undefined") {
    //     document.getElementById("PbnPlayOver").innerHTML = makeBlue("End of Play");
    //     if(theDeclarer == northPlayer || theDeclarer === southPlayer) {
    //         declarerTricks = tricksNS;
    //     } else {
    //         declarerTricks = tricksEW;
    //     }
    // }

    return {
        trickNumber: trickNumber,
        tricksNS: tricksNS,
        tricksEW: tricksEW,
        trickArray: trickArray,
        nextCardToPlayPointer: nextCardToPlayPointer,
        trickCardsPlayed: trickCardsPlayed,
        playAttitudePointer: playAttitudePointer,
        currentPlayerOnLead: currentPlayerOnLead,
        playerOnLead: playerOnLead,
        northCard: northCard,
        eastCard: eastCard,
        southCard: southCard,
        westCard: westCard,
        northPbnCards: removeResult.northPbnCards,
        eastPbnCards: removeResult.eastPbnCards,
        southPbnCards: removeResult.southPbnCards,
        westPbnCards: removeResult.westPbnCards
    };
}

function removeCardFromHand(state, playAttitudePointer, rawCardPlayed) {
    var theSuit = rawCardPlayed.substring(0,1);
    var theRank =  rawCardPlayed.substring(1,2);
    var theHand = "";

    let northPbnCards = JSON.parse(JSON.stringify(state.northPbnCards));
    let eastPbnCards = JSON.parse(JSON.stringify(state.eastPbnCards));
    let southPbnCards = JSON.parse(JSON.stringify(state.southPbnCards));
    let westPbnCards = JSON.parse(JSON.stringify(state.westPbnCards));

    switch (playAttitudePointer) {
        case northPlayer:
            switch (theSuit) {
                case "S":
                    theHand = northPbnCards[spades];
                    for(let i = 0; i < 13; i++) {
                        if(theHand[i] == theRank) {
                            theHand[i] = "X";
                        }
                    }

                    break;
                case "H":
                    theHand = northPbnCards[hearts];
                    for(let i = 0; i < 13; i++) {
                        if(theHand[i] == theRank) {
                            theHand[i] = "X";
                        }
                    }

                    break;
                case "D":
                    theHand = northPbnCards[diamonds];
                    for(let i=0; i < 13; i++) {
                        if(theHand[i] == theRank) {
                            theHand[i] = "X";
                        }
                    }

                    break;
                case "C":
                    theHand = northPbnCards[clubs];
                    for(let i = 0; i < 13; i++) {
                        if(theHand[i] == theRank) {
                            theHand[i] = "X";
                        }
                    }

                    break;
            }

            break;
        case eastPlayer:
            switch (theSuit) {
                case "S":
                    theHand = eastPbnCards[spades];
                    for(let i = 0; i < 13; i++) {
                        if(theHand[i] == theRank) {
                            theHand[i] = "X";
                        }
                    }

                    break;
                case "H":
                    theHand = eastPbnCards[hearts];
                    for(let i = 0; i < 13; i++) {
                        if(theHand[i] == theRank) {
                            theHand[i] = "X";
                        }
                    }

                    break;
                case "D":
                    theHand = eastPbnCards[diamonds];
                    for(let i = 0; i < 13; i++) {
                        if(theHand[i] == theRank) {
                            theHand[i] = "X";
                        }
                    }

                    break;
                case "C":
                    theHand = eastPbnCards[clubs];
                    for(let i=0; i < 13; i++) {
                        if(theHand[i] == theRank) {
                            theHand[i] = "X";
                        }
                    }

                    break;
            }

            break;
        case southPlayer:
            switch (theSuit) {
                case "S":
                    theHand = southPbnCards[spades];
                    for(let i = 0; i < 13; i++) {
                        if(theHand[i] == theRank) {
                            theHand[i] = "X";
                        }
                    }

                    break;
                case "H":
                    theHand = southPbnCards[hearts];
                    for(let i = 0; i < 13; i++) {
                        if(theHand[i] == theRank) {
                            theHand[i] = "X";
                        }
                    }

                    break;
                case "D":
                    theHand = southPbnCards[diamonds];
                    for(let i=0; i < 13; i++) {
                        if(theHand[i] == theRank) {
                            theHand[i] = "X";
                        }
                    }

                    break;
                case "C":
                    theHand = southPbnCards[clubs];
                    for(let i = 0; i < 13; i++) {
                        if(theHand[i] == theRank) {
                            theHand[i] = "X";
                        }
                    }

                    break;
            }

            break;
        case westPlayer:
            switch (theSuit) {
                case "S":
                    theHand = westPbnCards[spades];
                    for(let i = 0; i < 13; i++) {
                        if(theHand[i] == theRank) {
                            theHand[i] = "X";
                        }
                    }

                    break;
                case "H":
                    theHand = westPbnCards[hearts];
                    for(let i = 0; i < 13; i++) {
                        if(theHand[i] == theRank) {
                            theHand[i] = "X";
                        }
                    }

                    break;
                case "D":
                    theHand = westPbnCards[diamonds];
                    for(let i = 0; i < 13; i++) {
                        if(theHand[i] == theRank) {
                            theHand[i] = "X";
                        }
                    }

                    break;
                case "C":
                    theHand = westPbnCards[clubs];
                    for(let i = 0; i < 13; i++) {
                        if(theHand[i] == theRank) {
                            theHand[i] = "X";
                        }
                    }

                    break;
            }

            break;
    }

    return {
        northPbnCards: northPbnCards,
        eastPbnCards: eastPbnCards,
        southPbnCards: southPbnCards,
        westPbnCards: westPbnCards
    };
}

function findTrickWinner(trickArray, openingLeadPlayer, playerOnLead, trumps) {
    var cardsPlayed = new Array();
    var cardsPlayedArrayPointer;
    var leadSuit;
    var leadNumericRank;
    var trickWinner;
    var trickWinnerSuit;
    var trickWinnerNumericRank;
    var cardPlayedSuit;
    var cardPlayedNumericRank;
    for(let i = 0; i < 4; i++) {
        cardsPlayed[i]  = trickArray[i];
        cardsPlayedArrayPointer++;
    }

    switch (openingLeadPlayer) {
        case northPlayer:
            switch (playerOnLead) {
                case northPlayer:
                    cardsPlayedArrayPointer = 0;
                    break;
                case eastPlayer:
                    cardsPlayedArrayPointer = 1;
                    break;
                case southPlayer:
                    cardsPlayedArrayPointer = 2;
                    break;
                case westPlayer:
                    cardsPlayedArrayPointer = 3;
                    break;
            }

            break;

        case eastPlayer:
            switch (playerOnLead) {
                case northPlayer:
                    cardsPlayedArrayPointer = 3;
                    break;
                case eastPlayer:
                    cardsPlayedArrayPointer = 0;
                    break;
                case southPlayer:
                    cardsPlayedArrayPointer = 1;
                    break;
                case westPlayer:
                    cardsPlayedArrayPointer = 2;
                    break;
            }

            break;
        case southPlayer:
            switch (playerOnLead) {
                case northPlayer:
                    cardsPlayedArrayPointer = 2;
                    break;
                case eastPlayer:
                    cardsPlayedArrayPointer = 3;
                    break;
                case southPlayer:
                    cardsPlayedArrayPointer = 0;
                    break;
                case westPlayer:
                    cardsPlayedArrayPointer = 1;
                    break;
            }

            break;
        case westPlayer:
            switch (playerOnLead) {
                case northPlayer:
                    cardsPlayedArrayPointer = 1;
                    break;
                case eastPlayer:
                    cardsPlayedArrayPointer = 2;
                    break;
                case southPlayer:
                    cardsPlayedArrayPointer = 3;
                    break;
                case westPlayer:
                    cardsPlayedArrayPointer = 0;
                    break;
            }

            break;
    }

    leadSuit = trickWinnerSuit = findCardSuit(cardsPlayed[cardsPlayedArrayPointer]);
    leadNumericRank = trickWinnerNumericRank = findCardNumericRank(cardsPlayed[cardsPlayedArrayPointer]);
    trickWinner = 0;
    for(let i = 0; i < 4; i++) {
        cardPlayedSuit = findCardSuit(cardsPlayed[cardsPlayedArrayPointer]);
        cardPlayedNumericRank = findCardNumericRank(cardsPlayed[cardsPlayedArrayPointer]);
        if(trumps === notrumps) {
            if(cardPlayedSuit === leadSuit) {
                if(cardPlayedNumericRank >= trickWinnerNumericRank) {
                    trickWinner = cardsPlayedArrayPointer;
                    trickWinnerSuit = cardPlayedSuit;
                    trickWinnerNumericRank = cardPlayedNumericRank;
                }
            }
        } else {
            if(cardPlayedSuit === trumps) {
                if((trickWinnerSuit === trumps) && (cardPlayedNumericRank >= trickWinnerNumericRank)) {
                    trickWinner = cardsPlayedArrayPointer;
                    trickWinnerSuit = cardPlayedSuit;
                    trickWinnerNumericRank = cardPlayedNumericRank;
                } else {
                    if (trickWinnerSuit != trumps) {
                        trickWinner = cardsPlayedArrayPointer;
                        trickWinnerSuit = cardPlayedSuit;
                        trickWinnerNumericRank = cardPlayedNumericRank;
                    }
                }
            } else {
                if((cardPlayedSuit === leadSuit) && (trickWinnerSuit === leadSuit)) {
                    if(cardPlayedNumericRank >= trickWinnerNumericRank) {
                        trickWinner = cardsPlayedArrayPointer;
                        trickWinnerSuit = cardPlayedSuit;
                        trickWinnerNumericRank = cardPlayedNumericRank;
                    }
                }
            }
        }

        cardsPlayedArrayPointer ++;
        if(cardsPlayedArrayPointer > westPlayer) {
            cardsPlayedArrayPointer = northPlayer;
        }
    }

    return trickWinner;
}

function resetCards(state) {
    let result = {};

    result.nextCardToPlayPointer = 0;

    result.trickCardsPlayed = 0;
    result.playAttitudePointer = state.openingLeadPlayer;
    result.currentPlayerOnLead = state.openingLeadPlayer;
    result.playerOnLead = state.openingLeadPlayer;
    result.trickNumber = 0;
    result.tricksNS = 0
    result.tricksEW = 0;
    result.trickArray = setupTrickArray(0, state.play.playArray);
    result.northCard = ""
    result.eastCard = ""
    result.southCard = ""
    result.westCard = ""

    // document.getElementById("PbnPlayOver").innerHTML = "&nbsp;";
    // document.getElementById(pbnPlayDivs[northPlayer]).innerHTML = "&nbsp;";
    // document.getElementById(pbnPlayDivs[eastPlayer]).innerHTML =  "&nbsp;";
    // document.getElementById(pbnPlayDivs[southPlayer]).innerHTML =  "&nbsp;";
    // document.getElementById(pbnPlayDivs[westPlayer]).innerHTML =  "&nbsp;";
    // document.getElementById("PbnTrickNumber").innerHTML = "Tricks Played:";
    // document.getElementById("PbntricksNS").innerHTML = "NS Tricks:";
    // document.getElementById("PbntricksEW").innerHTML = "EW Tricks:";

    result.northPbnCards = [
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X']
    ];
    result.eastPbnCards = [
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X']
    ];
    result.southPbnCards = [
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X']
    ];
    result.westPbnCards = [
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
        ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X']
    ];


    dealCards(state.northCards, result.northPbnCards);
    dealCards(state.eastCards, result.eastPbnCards);
    dealCards(state.southCards, result.southPbnCards);
    dealCards(state.westCards, result.westPbnCards);
    // document.getElementById("PbnNorthSpades").innerHTML = getCardsInHand(northPbnCards[spades]);
    // document.getElementById("PbnNorthHearts").innerHTML = getCardsInHand(northPbnCards[hearts]);
    // document.getElementById("PbnNorthDiamonds").innerHTML = getCardsInHand(northPbnCards[diamonds]);
    // document.getElementById("PbnNorthClubs").innerHTML = getCardsInHand(northPbnCards[clubs]);
    // document.getElementById("PbnEastSpades").innerHTML = getCardsInHand(eastPbnCards[spades]);
    // document.getElementById("PbnEastHearts").innerHTML = getCardsInHand(eastPbnCards[hearts]);
    // document.getElementById("PbnEastDiamonds").innerHTML = getCardsInHand(eastPbnCards[diamonds]);
    // document.getElementById("PbnEastClubs").innerHTML = getCardsInHand(eastPbnCards[clubs]);
    // document.getElementById("PbnSouthSpades").innerHTML = getCardsInHand(southPbnCards[spades]);
    // document.getElementById("PbnSouthHearts").innerHTML = getCardsInHand(southPbnCards[hearts]);
    // document.getElementById("PbnSouthDiamonds").innerHTML = getCardsInHand(southPbnCards[diamonds]);
    // document.getElementById("PbnSouthClubs").innerHTML = getCardsInHand(southPbnCards[clubs]);
    // document.getElementById("PbnWestSpades").innerHTML = getCardsInHand(westPbnCards[spades]);
    // document.getElementById("PbnWestHearts").innerHTML = getCardsInHand(westPbnCards[hearts]);
    // document.getElementById("PbnWestDiamonds").innerHTML = getCardsInHand(westPbnCards[diamonds]);
    // document.getElementById("PbnWestClubs").innerHTML = getCardsInHand(westPbnCards[clubs]);
    return result;
}

function pbnData(state = initState, action) {
    switch (action.type) {
        case REQUEST_PBN:
            return Object.assign(
                {},
                initState
            );
        case RECEIVE_PBN:
            let tmpState = readPBN(action.pbnData);
            tmpState = Object.assign(
                {},
                tmpState,
                pbnParser(tmpState)
            );

            return Object.assign(
                {},
                tmpState,
                resetCards(tmpState)
            );
        case PREVIOUS_AUCTION:
            return Object.assign(
                {},
                state,
                previousAuction(state)
            );
            break;
        case NEXT_AUCTION:
            return Object.assign(
                {},
                state,
                nextAuction(state)
            );
            break;
        case SHOW_AUCTION:
            return Object.assign(
                {},
                state,
                showAuction(state)
            );
            break;
        case RESET_AUCTION:
            return Object.assign(
                {},
                state,
                resetAuction(state)
            );
            break;
        case PLAY_CARD:
            return Object.assign(
                {},
                state,
                playCard(state)
            );
            break;
        case RESET_CARDS:
            return Object.assign(
                {},
                state,
                resetCards(state)
            );
            break;
        default:
            return state;
    }
}

export default pbnData;